import { useEffect, useState } from 'react'
import { Modal } from 'components/dialog/Modals'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  fetchExposurePreview,
  hidePreview,
  setDeviceType,
} from 'features/dashboard/operation/keywordExposurePreview/keywordExposurePreviewSlice'
import Button from 'components/form/Button'
import classNames from 'classnames'
import { DeviceTypes } from 'features/Codes'
import { separateUrlProtocol } from 'utils'
import Loading from 'components/loading/Loading'
import useWindowDimensions from 'utils/hooks/useWindowDimensions'
import NoneAnchor from 'components/NoneAnchor'

const KeywordExposurePreviewModal = () => {
  const dispatch = useDispatch()
  const { isLoading, isShow, keyword, deviceType, ads } = useSelector(
    state => state.dashboard.operation.keywordExposurePreview,
    shallowEqual
  )
  const { height: windowHeight } = useWindowDimensions()
  const [maxHeight, setMaxHeight] = useState(376)

  useEffect(() => {
    if (keyword && isShow) {
      dispatch(fetchExposurePreview())
    }
  }, [dispatch, isShow, keyword, deviceType])
  useEffect(() => {
    if (windowHeight && windowHeight >= 764) {
      setMaxHeight(windowHeight - 388)
    }
  }, [windowHeight])
  useEffect(
    () => () => {
      dispatch(hidePreview())
    },
    [dispatch]
  )

  const handleRefresh = () => {
    dispatch(fetchExposurePreview())
  }
  const handleDeviceTypeChange = value => {
    dispatch(setDeviceType(value))
  }
  const handleClose = () => {
    dispatch(hidePreview())
  }
  return (
    <Modal on={isShow} className="status_layer">
      <div className="layer_head">
        <strong className="tit_layer">
          <span className="keyword_limit">&apos;{keyword}</span>&apos;키워드
          노출현황
        </strong>
      </div>
      <div className="layer_body">
        <p className="desc_info">
          노출현황은 광고그룹의 매체유형 속성이 검색 매체 &gt; 카카오인 경우를
          예시로 제공됩니다. 기본소재만을 사용한 미리보기이며, 입찰상황의 변화로
          인해 실제 노출현황과 차이가 있을 수 있습니다.
        </p>
        <div className="view_material">
          <div className="view_tit">
            <strong className="tit_view">미리보기</strong>
            <ul className="tab_view">
              <li
                className={classNames({
                  on: deviceType === DeviceTypes.MOBILE,
                })}>
                <NoneAnchor
                  className="link_tab"
                  onClick={() => {
                    handleDeviceTypeChange(DeviceTypes.MOBILE)
                  }}>
                  모바일
                </NoneAnchor>
              </li>
              <li className={classNames({ on: deviceType === DeviceTypes.PC })}>
                <NoneAnchor
                  className="link_tab"
                  onClick={() => {
                    handleDeviceTypeChange(DeviceTypes.PC)
                  }}>
                  PC
                </NoneAnchor>
              </li>
            </ul>
            <Button line disabled={isLoading} onClick={handleRefresh}>
              <span className="img_comm ico_refresh2">새로고침</span>
            </Button>
          </div>

          <div className="layer_scroll" style={{ maxHeight }}>
            {isLoading ? (
              <Loading />
            ) : ads.length > 0 ? (
              <div
                className={classNames('view_detail', {
                  view_mo: deviceType === DeviceTypes.MOBILE,
                  view_pc: deviceType === DeviceTypes.PC,
                })}>
                {ads.map(
                  ({
                    rank,
                    bizChannelUrl,
                    landingUrl,
                    title,
                    description,
                    isOwn,
                  }) => (
                    <div
                      key={`${deviceType.name}_${rank}`}
                      className={classNames('material_default', {
                        item_advertiser: isOwn,
                      })}>
                      <div className="inner_cont">
                        <strong className="ad_subject">
                          <a
                            href={landingUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="subject_link">
                            {title}
                          </a>
                        </strong>
                        <div className="ad_link">
                          {deviceType === DeviceTypes.MOBILE && (
                            <span className="ico_ad">광고</span>
                          )}
                          <a
                            href={landingUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="txt_link">
                            {separateUrlProtocol(bizChannelUrl)[1]}
                          </a>
                        </div>
                        <div className="ad_info">
                          <a
                            href={landingUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ad_desc ad_hospital">
                            {description}
                          </a>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            ) : (
              <div className="add_item">
                <p className="desc_info">
                  해당 키워드로 노출되는 광고 미리보기가 없습니다.
                </p>
              </div>
            )}
            <div className="view_detail view_native">
              <p className="txt_warn">
                실제 노출과 미리보기가 다를 수 있습니다.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="layer_foot">
        <NoneAnchor onClick={handleClose} className="btn_close">
          <span className="ico_comm ico_close">닫기</span>
        </NoneAnchor>
      </div>
    </Modal>
  )
}

export default KeywordExposurePreviewModal
